import React from 'react';
import { Meal } from '../../api/services/MealsService';
import styles from './MealDayDetailsPanel.module.css';
import SlideUpPanel from '../common/SlideUpPanel';
import { useTranslation } from '../../i18n/provider';

type Props = {
  open: boolean;
  date: string;
  meals: Meal[];
  loading: boolean;
  onClose: () => void;
};

const MealDayDetailsPanel: React.FC<Props> = ({ open, date, meals, loading, onClose }) => {
  const { t } = useTranslation();
  const totalCalories = meals.reduce((s, m) => s + m.calories, 0);
  const totalProtein = meals.reduce((s, m) => s + m.protein, 0);
  const totalCarbs = meals.reduce((s, m) => s + m.carbs, 0);
  const totalFats = meals.reduce((s, m) => s + m.fats, 0);

  return (
    <SlideUpPanel open={open} title={t('food.mealDetails.title')} subtitle={date} onClose={onClose}>
      <div className={styles.list}>
        {loading ? (
          <div className={styles.empty}>{t('food.mealDetails.loading')}</div>
        ) : meals.length === 0 ? (
          <div className={styles.empty}>{t('food.mealDetails.empty')}</div>
        ) : (
          meals.map((m) => (
            <div key={m.id} className={styles.row}>
              <div>
                <div className={styles.mealName}>{m.name}</div>
                <div className={styles.mealLabel}>{m.label || ''}</div>
              </div>
              <div className={styles.right}>
                <div className={styles.calories}>{m.calories} cal</div>
                <div className={styles.macros}>P: {m.protein}g • C: {m.carbs}g • F: {m.fats}g</div>
              </div>
            </div>
          ))
        )}
      </div>

      {!loading && meals.length > 0 && (
        <div className={styles.totals}>
          <div className={styles.totalsRow}>
            <div className={styles.totalsTitle}>{t('food.mealDetails.total')}</div>
            <div className={styles.highlight}>
              {totalCalories} cal • P: {totalProtein}g • C: {totalCarbs}g • F: {totalFats}g
            </div>
          </div>
        </div>
      )}
    </SlideUpPanel>
  );
};

export default MealDayDetailsPanel;
